import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router';
import Translate from '../layout/Translate';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/user';
import cookie from 'react-cookie';

export default class Facebook extends Component {


    componentDidMount () {
        this.props.userActions.initFacebook();
    }

    getRandomInt(min, max)
    {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    componentWillUpdate() {
        this.pageWidth = ReactDOM.findDOMNode(this.refs.facebook).clientWidth;
    }


    getAvatars () {
        let avatars = [],
            list = [],
            photoCount = parseInt((this.pageWidth+ 324)/82) * 3;
        for (var i = 1; i <= 150; i++) {
            list.push(i);
        }

        for (var i = 0; i < photoCount; i++) {
            let index = this.getRandomInt(0, list.length-1);


            avatars.push(<img className="facebook__avatar" src={"/static/fb/"+ list[index] + ".jpg"} key={i} />);
            list.splice(index, 1);
        }

        return avatars;
    }

    closeFacebook() {
        this.props.userActions.closeFacebook();
    }

    render() {
        let closeFacebook = cookie.load('closeFacebook');

        /*
        <div className={"facebook "} ref="facebook">
                {(!closeFacebook && (this.props.facebook && !this.props.facebook.close)) &&
                    <div>
                        <a href="https://www.facebook.com/BaikalNature/" rel="nofollow" target="_blank" className={"facebook__link "  + (this.props.blockClass?this.props.blockClass:"")}>
                            <div className="facebook__avatars">{this.getAvatars()}</div>
                            <div className="facebook__logo"></div>
                            <div className={"facebook__count " + this.props.lang}><Translate slug="facebook_us"/> 130K+</div>
                            <div className="facebook__go"><Translate slug="facebook_join"/> {this.facebookWidth}</div>
                        </a>
                        <div className="facebook__close" onClick={this.closeFacebook.bind(this)}></div>
                    </div>
                }
            </div>
         */

        return (
            <div ref="facebook"></div>
        );
    }
}



function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    }
}

function mapStateToProps (state) {
    return {
        translations: state.user.translations,
        facebook: state.user.facebook,
        lang: state.user.lang,
        slugVisible: state.user.slugVisible
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Facebook)




// WEBPACK FOOTER //
// ./src/common/components/popups/Facebook.js